module.exports = __webpack_public_path__ + "img/boat1.585fc800.jpg";